<template>
  <task-list :filter-status="filter.current" :values-blocks="['balance', 'debt']"></task-list>
</template>

<script>
import taskList from '@/components/TaskList'
import { useTasksStore } from '@/stores/tasks'
import { mapState } from 'pinia/dist/pinia'

export default {
  name: 'PageCurrent',
  components: {
    taskList,
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(useTasksStore, ['filter']),
  },
  methods: {

  },
  mounted () {

  },
}
</script>
